import { render, staticRenderFns } from "./tag-auth.vue?vue&type=template&id=32964e09&scoped=true&"
import script from "./tag-auth.vue?vue&type=script&lang=js&"
export * from "./tag-auth.vue?vue&type=script&lang=js&"
import style0 from "./tag-auth.vue?vue&type=style&index=0&id=32964e09&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32964e09",
  null
  
)

export default component.exports